var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:twitter-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2523 6.1711C21.5352 6.48048 20.7547 6.70314 19.9508 6.78985C20.7854 6.294 21.4104 5.51063 21.7086 4.58673C20.9254 5.05264 20.0674 5.37935 19.1727 5.55235C18.7987 5.15257 18.3464 4.83409 17.844 4.61675C17.3416 4.3994 16.7998 4.28786 16.2523 4.28907C14.0375 4.28907 12.2562 6.08438 12.2562 8.28751C12.2562 8.59688 12.2937 8.90626 12.3547 9.20392C9.03828 9.03048 6.08047 7.4461 4.11406 5.02032C3.75576 5.63231 3.568 6.32913 3.57031 7.03829C3.57031 8.42579 4.27578 9.64923 5.35156 10.3688C4.71759 10.3438 4.09846 10.1695 3.54453 9.86017V9.90938C3.54453 11.8524 4.91797 13.4625 6.74844 13.8328C6.40475 13.9221 6.05119 13.9678 5.69609 13.9688C5.43594 13.9688 5.18984 13.943 4.94141 13.9078C5.44766 15.4922 6.92187 16.643 8.67734 16.6805C7.30391 17.7563 5.58359 18.3891 3.71563 18.3891C3.38047 18.3891 3.07109 18.3774 2.75 18.3399C4.52187 19.4766 6.62422 20.1328 8.88828 20.1328C16.2383 20.1328 20.2602 14.0438 20.2602 8.7586C20.2602 8.58517 20.2602 8.41173 20.2484 8.23829C21.0266 7.66876 21.7086 6.96329 22.2523 6.1711Z",
    fill: "#12110B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterfill);
export default __webpack_public_path__ + "static/media/twitterfill.9bd5544f297e079c6e320e9eda23b301.svg";
export { ForwardRef as ReactComponent };